import React from 'react';
import ProgressCard from './ProgressCard';
const AccountCreatedProgressCard = () => (<ProgressCard title="Account created" completed lightBg/>);
export default AccountCreatedProgressCard;
